"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.image.alt': 'Avatar Assistente IA',
};
